import { z } from "zod";
/**
 * A loose UUID that actually accepts a GUID but warns if the value is not a valid UUID.
 */
export const looseUuid = (...args) => looseUuidImpl(undefined, ...args);
export const looseUuidImpl = (debugImpl, ...args) => z.guid(...args).check(({ value }) => {
    if (!z.uuid().safeParse(value).success) {
        debugImpl?.("Value is not a valid UUID");
    }
});
//# sourceMappingURL=looseUuid.js.map